import React from 'react';

export default function RetentionControls() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-semibold mb-2">Retention & Controls</h1>
      <p className="text-neutral-300 mb-6">How BoltOS handles recovery retention windows and advanced compliance controls.</p>

      <div className="space-y-6 text-sm text-neutral-300">
        <section>
          <h2 className="text-lg font-medium text-neutral-100 mb-2">Included (All Organizations)</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>12‑day recycle bin for soft‑deleted content (headlines, comments, attachments).</li>
            <li>Basic audit entry for each deletion and recovery operation.</li>
            <li>Best‑effort support; no immutable or legal hold guarantees.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-medium text-neutral-100 mb-2">Recovery Vault Tiers</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Essential</strong>: 30‑day retention, email notifications, business‑hours support.</li>
            <li><strong>Professional</strong>: 60‑day retention, dual‑approval purge protection, advanced audit logs, priority support (4h), bulk tools.</li>
            <li><strong>Enterprise</strong>: 90‑day+ retention, immutable audit trail, legal hold, cross‑region replication, 99.99% recovery SLA.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-medium text-neutral-100 mb-2">Compliance Notes</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Audit logs are retained long‑term for compliance and are separate from user‑facing recovery windows.</li>
            <li>Immutable audit and legal hold are available in Professional/Enterprise tiers.</li>
            <li>All operations are organization‑scoped and respect role‑based permissions.</li>
          </ul>
        </section>

        <div className="mt-6">
          <a href="/billing/recovery-tiers" className="underline">Back to Recovery Tiers</a>
        </div>
      </div>
    </div>
  );
}
